// 全站消息数量刷新：切号、退出、销毁后拒绝旧请求回写，网络失败保留当前数量。
export function createMessageCountRefresh(identity:()=>string,fetchCount:()=>Promise<unknown>,emit:(count:number)=>void){
 let sequence=0,disposed=false
 return {
  async refresh(){const current=identity(),request=++sequence;if(!current || disposed){if(!disposed)emit(0);return}try{const value=await fetchCount();if(!disposed && request===sequence && current===identity() && typeof value==='number' && Number.isSafeInteger(value) && value>=0)emit(value)}catch(_){/* 等待下一次收件箱轮询。 */}},
  reset(){sequence++;if(!disposed)emit(0)},
  dispose(){disposed=true;sequence++}
 }
}
